import { ANALYST_PRACTICES, Role } from '../store/Role';
import type { Team } from '../store/Team';

export const PRACTICE_LABELS: Record<string, string> = {
  cx: 'CX',
  security: 'Security',
  data_center: 'Data Center',
  cloud: 'Cloud'
};

export const practiceLabel = (practice: string): string => PRACTICE_LABELS[practice] ?? practice;

export const advisePractice = (roleNames: string[]): string | undefined =>
  roleNames.map((name) => ANALYST_PRACTICES[name]).find(Boolean);

// Mirrors TeamAssignmentRules in upstack_api: Admin and Support never sit on a team.
export const holdsTeamlessRole = (roleNames: string[]): boolean =>
  roleNames.includes(Role.ADMIN) || roleNames.includes(Role.SUPPORT);

export const needsAdviseTeam = (roleNames: string[]): boolean =>
  roleNames.includes(Role.ADVISE_TEAM_MANAGER) || advisePractice(roleNames) !== undefined;

export const eligibleAdviseTeams = (roleNames: string[], teams: Team[]): Team[] => {
  const practice = advisePractice(roleNames);
  return teams.filter((team) => team.practice && (!practice || team.practice === practice));
};

export const missingAdviseTeam = (roleNames: string[], team: unknown): boolean => needsAdviseTeam(roleNames) && !team;
